import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { LoginComponent } from './components/login.component'
import { CreateAgentComponent } from './create-agent/create-agent.component'
import { AgentLinkComponent } from './agent-link/agent-link.component'

const routes: Routes = [{ path: 'login', component: LoginComponent }]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
